import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDownIcon, FlagIcon, HeartHandshakeIcon, MailIcon, ShieldIcon } from 'lucide-react';
import { BrandMark } from '../../components/BrandMark';
import { PageHeader } from '../../components/PageHeader';
import { SettingsGroup, SettingsRow } from '../../components/SettingsList';
import { Card, SectionTitle } from '../../components/ui/Card';
import { APP_VERSION, faq } from '../../data/settings';
import { useLocale } from '../../contexts/LocaleContext';
export function HelpSupport() {
  const {
    t,
    tl
  } = useLocale();
  const navigate = useNavigate();
  const [open, setOpen] = useState<string | null>(faq[0].id);
  return <div className="px-2 pb-2" data-id="element-3402" data-mp="2ygapkphtpzy4">
      <PageHeader title={t('settings.help')} subtitle={t('help.subtitle')} showBack data-id="element-3403" data-mp="2yezq31vevect" />

      <SectionTitle data-id="element-3404" data-mp="2apotlwl3g64h">{t('help.faq')}</SectionTitle>
      <ul className="rounded-card border border-sand-line bg-white/70 px-2" data-id="element-3405" data-mp="25rwqs7iwuzli">
        {faq.map(entry => {
        const expanded = open === entry.id;
        return <li key={entry.id} className="border-b border-sand-line last:border-b-0" data-id="element-3406" data-mp="3ru3x28f1d0m5">
              <button type="button" aria-expanded={expanded} onClick={() => setOpen(expanded ? null : entry.id)} className="flex min-h-[52px] w-full items-center gap-2 py-2 text-left" data-id="element-3407" data-mp="3vvyw169hv1wr">
                <span className="min-w-0 flex-1 text-[13.5px] font-medium text-deep" data-id="element-3408" data-mp="38y42qqyl5kze">
                  {tl(entry.question)}
                </span>
                <ChevronDownIcon size={16} className={`shrink-0 text-muted transition-transform duration-150 ease-brand ${expanded ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-3409" data-mp="3d10epytmeiud" />
              </button>
              {expanded && <p className="pb-2 text-[12.5px] leading-relaxed text-muted" data-id="element-3410" data-mp="126cxz75679ge">
                  {tl(entry.answer)}
                </p>}
            </li>;
      })}
      </ul>

      <div className="mt-3" data-id="element-3411" data-mp="7k5p8vvw6ddf">
        <SectionTitle data-id="element-3412" data-mp="7iunt2px5hph">{t('help.contactGroup')}</SectionTitle>
        <SettingsGroup data-id="element-3413" data-mp="mgmzfjschlye">
          <SettingsRow label={t('help.contact')} hint="suporte@beelyv.com" icon={<MailIcon size={17} data-id="element-3415" data-mp="hiv6qnjvlvt5" />} data-id="element-3414" data-mp="mfvf55477anf" />
          <SettingsRow label={t('help.report')} hint={t('help.reportHint')} icon={<FlagIcon size={17} data-id="element-3417" data-mp="3kyk9hk4ooqno" />} data-id="element-3416" data-mp="hfzdhciz3vb1" />
          <SettingsRow label={t('help.guidelines')} icon={<HeartHandshakeIcon size={17} data-id="element-3419" data-mp="3ikhtq24mram" />} data-id="element-3418" data-mp="3kzvaxdanpmbm" />
          <SettingsRow label={t('help.safety')} icon={<ShieldIcon size={17} data-id="element-3421" data-mp="3uw6o05i2mg74" />} data-id="element-3420" data-mp="3k5cdfofya8h" />
        </SettingsGroup>
      </div>

      <div className="mt-3" data-id="element-3422" data-mp="3uuvpak3hfymv">
        <SectionTitle data-id="element-3423" data-mp="376m85vh7rz22">{t('help.about')}</SectionTitle>
        <Card className="p-2" data-id="element-3424" data-mp="37518xsjyfrxv">
          <div className="flex items-center gap-2" data-id="element-3425" data-mp="328asv585gwcg">
            <BrandMark size={34} data-id="element-3426" data-mp="327spzpqzfjvk" />
            <div className="min-w-0 flex-1" data-id="element-3427" data-mp="1hq0edpxlnuh3">
              <p className="text-[13.5px] font-bold text-deep" data-id="element-3428" data-mp="1hp8i0cw6hspr">BEELYV</p>
              <p className="bee-num mt-[2px] text-[11.5px] text-muted" data-id="element-3429" data-mp="1mh8jwavt6voz">
                {t('help.version')} {APP_VERSION}
              </p>
            </div>
          </div>
          <p className="mt-2 text-[12.5px] leading-relaxed text-muted" data-id="element-3430" data-mp="1cqx67wmbp84w">
            {t('help.aboutBody')}
          </p>
        </Card>
      </div>

      <div className="mt-3" data-id="element-3431" data-mp="20hjbxh8uugbq">
        <SettingsGroup data-id="element-3432" data-mp="20hb443rla17e">
          <SettingsRow label={t('help.states')} hint={t('help.statesHint')} onClick={() => navigate('/estados')} data-id="element-3433" data-mp="25fkve3a70hnq" />
        </SettingsGroup>
      </div>
    </div>;
}